import { useContext, useEffect } from "react";
import { useNavigate, Link } from "react-router";

import { Context } from "../../models/context";
import "./home.css";

export default function Home() {
    const context = useContext(Context);
    const navigate = useNavigate();

    useEffect(() => {
        if (!context.user) navigate("/login");
    }, [context.user, navigate]);

    return <>
        <div id="home-page">
            <div className="container" id="growth-home">
                <h1>Welcome to Growth Spurt</h1>
                <p>Click on the buttons below to find information about Growth Spurt or the apps the RLL Lab has developed.</p>
                <p>Use the navigation banner in the top right corner to manage Growth Spurt.</p>
                

                {/* TODO: Update home page so it looks cooler. Have links to a page with links to the various apps (and brief descriptions), 
            basic information about GrowthSpurt, anything else that might be fun or interesting */}

                <div id="home-columns">
                    <Link to="about">
                        <div className="link container">About GrowthSpurt</div>
                    </Link>
                    <Link to="appLinks">
                        <div className="link container">Our Apps</div>
                    </Link>
                </div>
            </div>
        </div>
    </>;
}